import { render, staticRenderFns } from "./TranshipmentPreview.vue?vue&type=template&id=219a5569"
import script from "./TranshipmentPreview.vue?vue&type=script&lang=js"
export * from "./TranshipmentPreview.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentPreview.vue?vue&type=style&index=0&id=219a5569&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports